import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly http = inject(HttpClient);

  getUrl(path: string): string {
    return `${environment.marketplaceApiUrl}/${path}`;
  }

  get<T>(path: string, params?: HttpParams, context?: HttpContext): Observable<T> {
    return this.http.get<T>(this.getUrl(path), { params, context });
  }

  post<T>(path: string, body: unknown): Observable<T> {
    return this.http.post<T>(this.getUrl(path), body);
  }

  postFormData<T>(path: string, formData: FormData, params?: HttpParams): Observable<T> {
    return this.http.post<T>(this.getUrl(path), formData, { params });
  }

  put<T>(path: string, body: unknown): Observable<T> {
    return this.http.put<T>(this.getUrl(path), body);
  }

  patch<T>(path: string, body: unknown): Observable<T> {
    return this.http.patch<T>(this.getUrl(path), body);
  }

  delete<T>(path: string): Observable<T> {
    return this.http.delete<T>(this.getUrl(path));
  }
}
